var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "create-chatbot-wrapper" },
    [
      _vm.websiteBuilder
        ? _c("WebsiteChatbotBuilder", {
            on: {
              cancel: function () {
                return (_vm.websiteBuilder = false)
              },
            },
          })
        : _c("div", { staticClass: "create-chatbot" }, [
            _c(
              "div",
              { staticClass: "sticky-header" },
              [
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("chatbotv2.setUpYourChatbot"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "description" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("chatbotv2.setUpYourChatbotDesc")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    staticClass: "btnCloseCb",
                    attrs: { small: "" },
                    on: { click: _vm.close },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("close"),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "items" }, [
              _c(
                "div",
                {
                  staticClass: "block block-ai block-ai-bot",
                  on: { click: _vm.openAIBotWizard },
                },
                [
                  _c("div", { staticClass: "ai-badge" }, [
                    _c("span", { staticClass: "default-tag" }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.recommended"))),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("auto.artificialIntelligence"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "icon" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("psychology"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.aiBot"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.aiBotDesc"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "block block-scratch",
                  on: { click: _vm.createBlankStory },
                },
                [
                  _c("div", { staticClass: "icon" }, [
                    _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.blankBot"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.blankBotDesc"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "block block-ai",
                  on: { click: _vm.channelNotAvailable },
                },
                [
                  _c("div", { staticClass: "ai-badge" }, [
                    _c("span", { staticClass: "lang" }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.englishTurkish"))),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("auto.artificialIntelligence"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "icon" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("public"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(_vm.$t("auto.chatbotWizardWebsite"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("chatbotv2.websiteDesc")) +
                        "\n                "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "divider-items" }, [
                _c(
                  "div",
                  { staticClass: "half-template-area" },
                  [
                    _c("a-divider", { staticClass: "template-divider" }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.readyTemplates"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "half-template-items first" },
                      _vm._l(_vm.getFilteredTemplates(), function (template) {
                        return _c(
                          "div",
                          {
                            key: template.slug,
                            staticClass: "block block-ai block-template",
                            on: {
                              click: function ($event) {
                                _vm.selectedTemplate = template
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "ai-badge" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("chatbotv2.basicTemplate"))
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "icon" }, [
                              _c("img", {
                                attrs: { src: template.imageUrl, alt: "" },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "name" }, [
                              _vm._v(_vm._s(template.name[_vm.currentLang])),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "description" }, [
                              _vm._v(
                                _vm._s(
                                  template.shortDescription[_vm.currentLang]
                                )
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "half-template-area" },
                  [
                    _c("a-divider", { staticClass: "template-divider" }, [
                      _vm._v(
                        _vm._s(_vm.$t("chatbotv2.templatesFromTheIndustry"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "half-template-items" },
                      _vm._l(_vm.getFilteredAiTemplates(), function (template) {
                        return _c(
                          "div",
                          {
                            key: template.slug,
                            staticClass: "block block-ai block-template",
                            on: {
                              click: function ($event) {
                                _vm.selectedTemplate = template
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "ai-badge" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("chatbotv2.proTemplate"))),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "icon" }, [
                              _c("img", {
                                attrs: { src: template.imageUrl, alt: "" },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "name" }, [
                              _vm._v(_vm._s(template.name[_vm.currentLang])),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "description" }, [
                              _vm._v(
                                _vm._s(
                                  template.shortDescription[_vm.currentLang]
                                )
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
      _vm._v(" "),
      _vm.openAIModal
        ? _c(
            "Modal2",
            {
              staticClass: "open-ai-wrapper",
              attrs: { id: "openAI", showTitle: false, showFooter: false },
              on: {
                cancel: function ($event) {
                  _vm.openAIModal = false
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "open-ai-modal-body" },
                [
                  _c("ApiKeyIcon", {
                    staticStyle: { width: "400px", height: "250px" },
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "open-ai-modal-text" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("chatbotv2.yourNeedEnterYourOpenAi")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "delete-modal-btn" }, [
                    _c(
                      "button",
                      {
                        staticClass: "push-btn-give-up",
                        on: {
                          click: function ($event) {
                            _vm.openAIModal = false
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("message.cancel")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "push-btn",
                        on: { click: _vm.openAIChannelCreate },
                      },
                      [_vm._v(_vm._s(_vm.$t("chatbotv2.createOpenAiKey")))]
                    ),
                  ]),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedTemplate
        ? _c(
            "a-modal",
            {
              staticClass: "template-modal",
              attrs: {
                centered: "",
                visible: !!_vm.selectedTemplate,
                footer: null,
                closable: true,
              },
              on: {
                cancel: function ($event) {
                  _vm.selectedTemplate = null
                },
              },
            },
            [
              _c("div", { staticClass: "modal-import-template" }, [
                _c("div", { staticClass: "description" }, [
                  _c("div", { staticClass: "top" }, [
                    _c("img", {
                      staticClass: "image",
                      attrs: {
                        src: _vm.selectedTemplate.imageUrl,
                        alt: _vm.selectedTemplate.name,
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "header" },
                      [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.selectedTemplate.name[_vm.currentLang]
                              ) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-button",
                          {
                            attrs: {
                              type: "primary",
                              ghost: "",
                              disbled: _vm.importing,
                              loading: _vm.importing,
                              disabled: !_vm.selectedTemplate.enabled,
                            },
                            on: {
                              click: function () {
                                return _vm.createStory(
                                  _vm.selectedTemplate.slug
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.importing
                                    ? _vm.$t("chatbotv2.importing")
                                    : _vm.$t("chatbotv2.importBot")
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tpl-markdown description-content" },
                    [
                      _c("p", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.selectedTemplate.description[
                                _vm.currentLang
                              ].split("\n")[0]
                            ) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.selectedTemplate.description[_vm.currentLang].split(
                        "\n"
                      )[3] !== "" && !_vm.isThatAI(_vm.selectedTemplate)
                        ? _c("div", [
                            _c("p", [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.$t("chatbotv2.keyFeatures")) + ":"
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "ul",
                              _vm._l(
                                _vm.$_.drop(
                                  _vm.selectedTemplate.description[
                                    _vm.currentLang
                                  ].split("\n"),
                                  3
                                ),
                                function (keyFeature, index) {
                                  return _c("li", { key: index }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          keyFeature.replace("*", "").trim()
                                        ) +
                                        "\n                            "
                                    ),
                                  ])
                                }
                              ),
                              0
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "details" }, [
                  _c("div", { staticClass: "section" }, [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.lastUpdate"))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "data" }, [
                      _vm._v(
                        _vm._s(_vm.timeHumanize(_vm.selectedTemplate.updatedAt))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section" }, [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.categories"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "data",
                        staticStyle: {
                          "flex-direction": "column",
                          "align-items": "flex-start",
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.selectedTemplate.categories[
                                _vm.currentLang
                              ].join(", ")
                            ) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section" }, [
                    _vm.$i18n.locale === "en" || _vm.$i18n.locale === "ru"
                      ? _c("div", { staticClass: "label" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("chatbotv2.worksWith")) +
                              "\n                    "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "data",
                        staticStyle: {
                          "flex-direction": "column",
                          "align-items": "flex-start",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "display-integrations" },
                          [
                            _c("img", {
                              staticClass: "icon supsis",
                              attrs: { src: "/static/img/supsis-logo3.png" },
                            }),
                            _vm._v(" "),
                            _c("WhatsappV1", {
                              staticClass: "templates-whatsapp-icon",
                              attrs: { color: "#28AC01" },
                            }),
                            _vm._v(" "),
                            _c("WhatsappV2", {
                              staticClass: "templates-whatsapp-icon",
                              attrs: { color: "#28AC01" },
                            }),
                            _vm._v(" "),
                            _c("WhatsappBusinessIcon", {
                              staticClass: "templates-whatsapp-icon",
                              attrs: { color: "#28AC01" },
                            }),
                            _vm._v(" "),
                            _c("TelegramIcon"),
                            _vm._v(" "),
                            _c("InstagramIcon", {
                              attrs: { "special-background-mode": "" },
                            }),
                            _vm._v(" "),
                            _c("MessengerIcon"),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.$i18n.locale === "tr"
                      ? _c("div", { staticClass: "label" }, [
                          _vm._v(_vm._s(_vm.$t("chatbotv2.worksWith"))),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          staticClass: "ai-bot-wizard-modal",
          attrs: {
            centered: "",
            visible: _vm.aiBotWizard,
            footer: null,
            closable: true,
            width: 820,
            maskClosable: false,
          },
          on: { cancel: _vm.closeAIBotWizard },
        },
        [
          _c("div", { staticClass: "ai-bot-wizard" }, [
            _c(
              "div",
              { staticClass: "wizard-steps-indicator" },
              [
                _c(
                  "div",
                  {
                    staticClass: "wizard-step-item",
                    class: {
                      active: _vm.wizardStep === 2,
                      done: _vm.wizardStep > 2,
                    },
                  },
                  [
                    _c("div", { staticClass: "step-circle" }, [
                      _vm.wizardStep > 2
                        ? _c("i", { staticClass: "material-icons" }, [
                            _vm._v("check"),
                          ])
                        : _c("span", [_vm._v("1")]),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "step-label" }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.ragMethod"))),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "step-connector",
                  class: { done: _vm.wizardStep > 2 },
                }),
                _vm._v(" "),
                _vm.wizardRagMethod === "supsis-rag"
                  ? [
                      _c(
                        "div",
                        {
                          staticClass: "wizard-step-item",
                          class: {
                            active: _vm.wizardStep === 3,
                            done: _vm.wizardStep > 3,
                          },
                        },
                        [
                          _c("div", { staticClass: "step-circle" }, [
                            _vm.wizardStep > 3
                              ? _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("check"),
                                ])
                              : _c("span", [_vm._v("2")]),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "step-label" }, [
                            _vm._v(_vm._s(_vm.$t("chatbotv2.embedding"))),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "step-connector",
                        class: { done: _vm.wizardStep > 3 },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "wizard-step-item",
                          class: { active: _vm.wizardStep === 4 },
                        },
                        [
                          _c("div", { staticClass: "step-circle" }, [
                            _c("span", [_vm._v("3")]),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "step-label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("auto.chatbotWizardLlmModel"))
                            ),
                          ]),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _vm.wizardStep === 2
              ? _c("div", { staticClass: "wizard-step-content" }, [
                  _c("div", { staticClass: "wizard-step-title" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.wizardStepTitleRag"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "wizard-step-desc" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.wizardStepDescRag"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "wizard-rag-cards" }, [
                    _c(
                      "div",
                      {
                        staticClass: "wizard-rag-card",
                        class: {
                          selected: _vm.wizardRagMethod === "supsis-rag",
                        },
                        on: {
                          click: function ($event) {
                            _vm.wizardRagMethod = "supsis-rag"
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "wizard-rag-card-header" },
                          [
                            _c("span", { staticClass: "card-title" }, [
                              _vm._v(_vm._s(_vm.$t("chatbotv2.supsisRag"))),
                            ]),
                            _vm._v(" "),
                            _c("a-tag", { attrs: { color: "blue" } }, [
                              _vm._v(_vm._s(_vm.$t("chatbotv2.new"))),
                            ]),
                            _vm._v(" "),
                            _vm.wizardRagMethod === "supsis-rag"
                              ? _c("a-tag", { attrs: { color: "green" } }, [
                                  _vm._v(_vm._s(_vm.$t("chatbotv2.selected"))),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-desc" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("chatbotv2.supsisRagDesc")) +
                              "\n                        "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "wizard-rag-card",
                        class: {
                          selected: _vm.wizardRagMethod === "openai-rag",
                        },
                        on: {
                          click: function ($event) {
                            _vm.wizardRagMethod = "openai-rag"
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "wizard-rag-card-header" },
                          [
                            _c("img", {
                              staticClass: "rag-logo",
                              attrs: {
                                src: "https://openai.com/favicon.ico",
                                onerror: "this.style.display='none'",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "card-title" }, [
                              _vm._v(_vm._s(_vm.$t("chatbotv2.openaiRag"))),
                            ]),
                            _vm._v(" "),
                            _vm.wizardRagMethod === "openai-rag"
                              ? _c("a-tag", { attrs: { color: "green" } }, [
                                  _vm._v(_vm._s(_vm.$t("chatbotv2.selected"))),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-desc" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("chatbotv2.openaiRagDesc")) +
                              "\n                        "
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.wizardRagMethod === "supsis-rag"
                    ? _c(
                        "div",
                        { staticClass: "wizard-channel-section" },
                        [
                          _c("div", { staticClass: "section-label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("chatbotv2.openRouterChannel")) +
                                " "
                            ),
                            _c("span", { staticClass: "required-star" }, [
                              _vm._v("*"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "section-desc" }, [
                            _vm._v(
                              _vm._s(_vm.$t("chatbotv2.openRouterChannelDesc"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "chatbotv2.selectOpenRouterChannel"
                                ),
                              },
                              model: {
                                value: _vm.wizardOpenrouterChannel,
                                callback: function ($$v) {
                                  _vm.wizardOpenrouterChannel = $$v
                                },
                                expression: "wizardOpenrouterChannel",
                              },
                            },
                            _vm._l(_vm.openrouterChannels, function (ch) {
                              return _c(
                                "a-select-option",
                                { key: ch._id, attrs: { value: ch._id } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(ch.name) +
                                      "\n                            "
                                  ),
                                  ch.payload && ch.payload.keyMode === "byok"
                                    ? _c(
                                        "span",
                                        { staticStyle: { color: "#1890ff" } },
                                        [_vm._v(" (BYOK - %10 ücret)")]
                                      )
                                    : _c(
                                        "span",
                                        { staticStyle: { color: "#52c41a" } },
                                        [_vm._v(" (Supsis API)")]
                                      ),
                                ]
                              )
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _vm.openrouterChannels.length === 0
                            ? _c(
                                "div",
                                { staticStyle: { "margin-top": "10px" } },
                                [
                                  _c("a-alert", {
                                    attrs: {
                                      type: "warning",
                                      "show-icon": "",
                                      message: _vm.$t(
                                        "chatbotv2.noOpenRouterChannel"
                                      ),
                                      description: _vm.$t(
                                        "chatbotv2.createOpenRouterChannelDesc"
                                      ),
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.wizardRagMethod === "openai-rag"
                    ? _c("div", { staticClass: "wizard-channel-section" }, [
                        _vm.openAIChannel
                          ? _c(
                              "div",
                              [
                                _c("a-alert", {
                                  attrs: {
                                    type: "success",
                                    "show-icon": "",
                                    message: _vm.$t(
                                      "chatbotv2.openaiChannelExists"
                                    ),
                                  },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              [
                                _c("a-alert", {
                                  attrs: {
                                    type: "error",
                                    "show-icon": "",
                                    message: _vm.$t(
                                      "chatbotv2.openaiChannelNotFound"
                                    ),
                                    description: _vm.$t(
                                      "chatbotv2.createOpenaiChannelDesc"
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.wizardStep === 3
              ? _c("div", { staticClass: "wizard-step-content" }, [
                  _c("div", { staticClass: "wizard-step-title" }, [
                    _vm._v(
                      _vm._s(_vm.$t("chatbotv2.wizardStepTitleEmbedding"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "wizard-step-desc" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.wizardStepDescEmbedding"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wizard-embedding-cards" },
                    _vm._l(_vm.wizardEmbeddingModels, function (em) {
                      return _c(
                        "div",
                        {
                          key: em.id,
                          staticClass: "wizard-embedding-card",
                          class: {
                            selected: _vm.wizardEmbeddingModel === em.id,
                          },
                          on: {
                            click: function ($event) {
                              _vm.wizardEmbeddingModel = em.id
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "em-header" },
                            [
                              _c("span", { staticClass: "em-name" }, [
                                _vm._v(_vm._s(em.name)),
                              ]),
                              _vm._v(" "),
                              em.recommended
                                ? _c("a-tag", { attrs: { color: "green" } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("chatbotv2.recommended"))
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.wizardEmbeddingModel === em.id
                                ? _c(
                                    "i",
                                    { staticClass: "material-icons em-check" },
                                    [_vm._v("check_circle")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "em-meta" }, [
                            _c("span", [
                              _vm._v(_vm._s(em.contextLength) + " token"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(em.dimensions) + " boyut"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "em-desc" }, [
                            _vm._v(_vm._s(em.description)),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.wizardStep === 4
              ? _c(
                  "div",
                  { staticClass: "wizard-step-content wizard-llm-step" },
                  [
                    _c("div", { staticClass: "wizard-step-title" }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.wizardStepTitleLlm"))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "wizard-step-desc" }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.wizardStepDescLlm"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "wizard-selected-model-bar" },
                      [
                        _c("span", { staticClass: "selected-label" }, [
                          _vm._v(_vm._s(_vm.$t("chatbotv2.selected")) + ":"),
                        ]),
                        _vm._v(" "),
                        _c("b", { staticClass: "selected-model-name" }, [
                          _vm._v(_vm._s(_vm.wizardLLMModel)),
                        ]),
                        _vm._v(" "),
                        !_vm.wizardORLoading &&
                        _vm.wizardORModels.length === 0 &&
                        !_vm.wizardORError
                          ? _c(
                              "a-button",
                              {
                                attrs: { type: "link", size: "small" },
                                on: { click: _vm.loadWizardORModels },
                              },
                              [
                                _c(
                                  "i",
                                  {
                                    staticClass: "material-icons",
                                    staticStyle: {
                                      "font-size": "14px",
                                      "vertical-align": "middle",
                                    },
                                  },
                                  [_vm._v("refresh")]
                                ),
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.$t("chatbotv2.loadModels")) +
                                    "\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.wizardORError
                          ? _c(
                              "a-button",
                              {
                                attrs: { type: "link", size: "small" },
                                on: { click: _vm.loadWizardORModels },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.$t("chatbotv2.retry")) +
                                    "\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.wizardORLoading
                      ? _c(
                          "div",
                          { staticClass: "wizard-or-loading" },
                          [
                            _c("a-spin", {
                              attrs: { tip: _vm.$t("chatbotv2.loadingModels") },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.wizardORError && !_vm.wizardORLoading
                      ? _c(
                          "div",
                          { staticStyle: { "margin-bottom": "10px" } },
                          [
                            _c("a-alert", {
                              attrs: {
                                type: "error",
                                message: _vm.wizardORError,
                                "show-icon": "",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.wizardORLoading && _vm.wizardORModels.length > 0
                      ? [
                          _c(
                            "a-input",
                            {
                              staticStyle: { "margin-bottom": "12px" },
                              attrs: {
                                placeholder: _vm.$t("chatbotv2.search"),
                                "allow-clear": "",
                              },
                              on: {
                                change: function ($event) {
                                  _vm.wizardORPage = 1
                                },
                              },
                              model: {
                                value: _vm.wizardORSearchQuery,
                                callback: function ($$v) {
                                  _vm.wizardORSearchQuery = $$v
                                },
                                expression: "wizardORSearchQuery",
                              },
                            },
                            [
                              _c(
                                "i",
                                {
                                  staticClass: "material-icons",
                                  staticStyle: {
                                    "font-size": "16px",
                                    color: "#bbb",
                                    "line-height": "1",
                                  },
                                  attrs: { slot: "prefix" },
                                  slot: "prefix",
                                },
                                [_vm._v("search")]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "wizard-or-cards" },
                            _vm._l(_vm.wizardPaginatedORModels, function (m) {
                              return _c(
                                "div",
                                {
                                  key: m.id,
                                  staticClass: "wizard-or-card",
                                  class: {
                                    "is-selected": _vm.wizardLLMModel === m.id,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.wizardLLMModel = m.id
                                    },
                                  },
                                },
                                [
                                  _vm.wizardLLMModel === m.id
                                    ? _c(
                                        "div",
                                        { staticClass: "selected-ribbon" },
                                        [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [_vm._v("check_circle")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("chatbotv2.selected")
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "or-provider" }, [
                                    _vm._v(_vm._s(_vm.getWizardProvider(m.id))),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "or-model-name" }, [
                                    _vm._v(_vm._s(m.name || m.id)),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "or-model-id" }, [
                                    _vm._v(_vm._s(m.id)),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "or-stats" }, [
                                    m.context_length
                                      ? _c("span", { staticClass: "stat" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatWizardContextLength(
                                                m.context_length
                                              )
                                            )
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "stat" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatWizardPrice(m, "prompt")
                                        ) + "/1M in"
                                      ),
                                    ]),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _vm.wizardFilteredORModels.length >
                          _vm.wizardORPageSize
                            ? _c(
                                "div",
                                { staticClass: "wizard-or-pagination" },
                                [
                                  _c("a-pagination", {
                                    attrs: {
                                      current: _vm.wizardORPage,
                                      total: _vm.wizardFilteredORModels.length,
                                      "page-size": _vm.wizardORPageSize,
                                      size: "small",
                                    },
                                    on: { change: _vm.onWizardPageChange },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "wizard-routing-section" },
                      [
                        _c("div", { staticClass: "section-label" }, [
                          _vm._v(_vm._s(_vm.$t("chatbotv2.routingStrategy"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-radio-group",
                          {
                            attrs: { size: "small" },
                            model: {
                              value: _vm.wizardRoutingStrategy,
                              callback: function ($$v) {
                                _vm.wizardRoutingStrategy = $$v
                              },
                              expression: "wizardRoutingStrategy",
                            },
                          },
                          [
                            _c(
                              "a-radio-button",
                              { attrs: { value: "default" } },
                              [_vm._v("Fiyat Dengeli")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-radio-button",
                              { attrs: { value: "price" } },
                              [_vm._v("En Ucuz")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-radio-button",
                              { attrs: { value: "throughput" } },
                              [_vm._v("En Hızlı")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-radio-button",
                              { attrs: { value: "latency" } },
                              [_vm._v("En Düşük Gecikme")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.wizardORModels.length > 0
                      ? _c(
                          "div",
                          { staticClass: "wizard-fallback-section" },
                          [
                            _c("div", { staticClass: "section-label" }, [
                              _vm._v(
                                _vm._s(_vm.$t("chatbotv2.fallbackModels")) + " "
                              ),
                              _c("span", { staticClass: "section-hint" }, [
                                _vm._v(
                                  "(" +
                                    _vm._s(_vm.$t("chatbotv2.optional")) +
                                    ")"
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "section-desc" }, [
                              _vm._v(
                                _vm._s(_vm.$t("chatbotv2.fallbackModelsDesc"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  mode: "multiple",
                                  placeholder: _vm.$t(
                                    "chatbotv2.selectFallbackModel"
                                  ),
                                  "filter-option": _vm.wizardFallbackFilter,
                                },
                                model: {
                                  value: _vm.wizardFallbacks,
                                  callback: function ($$v) {
                                    _vm.wizardFallbacks = $$v
                                  },
                                  expression: "wizardFallbacks",
                                },
                              },
                              _vm._l(
                                _vm.wizardFilteredORModels.slice(0, 100),
                                function (m) {
                                  return _c(
                                    "a-select-option",
                                    { key: m.id, attrs: { value: m.id } },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(m.id) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "wizard-footer" },
              [
                _c("a-button", { on: { click: _vm.closeAIBotWizard } }, [
                  _vm._v(_vm._s(_vm.$t("message.cancel"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "wizard-footer-right" },
                  [
                    _vm.wizardStep > 2
                      ? _c("a-button", { on: { click: _vm.wizardBack } }, [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              staticStyle: {
                                "font-size": "16px",
                                "vertical-align": "middle",
                              },
                            },
                            [_vm._v("arrow_back")]
                          ),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("chatbotv2.backup")) +
                              "\n                    "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled: !_vm.wizardCanNext,
                          loading: _vm.wizardCreating,
                        },
                        on: { click: _vm.wizardNext },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.wizardNextLabel) +
                            "\n                        "
                        ),
                        !_vm.wizardCreating &&
                        _vm.wizardNextLabel !== _vm.$t("message.create")
                          ? _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                staticStyle: {
                                  "font-size": "16px",
                                  "vertical-align": "middle",
                                  "margin-left": "4px",
                                },
                              },
                              [_vm._v("arrow_forward")]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }